export default __webpack_public_path__ + "static/media/mobile-payment.9f64d8d1.svg";